import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_MENUS,
  DELETE_MENU,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

const Menus: React.FC = () => {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/navigation/menus/${id}`);
  };

  const getLinksNumber = (data: any) => {
    return Array.isArray(data.links) ? data.links.length : 0;
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        title={I18n.get.menu.labels.menus}
        operations={{
          category: "menus",
          get: GET_MENUS,
          delete: DELETE_MENU,
        }}
        columns={[
          { title: I18n.get.form.labels.name, field: "name", width: 150 },
          { title: I18n.get.form.labels.title, field: "title", width: 150 },
          {
            title: I18n.get.menu.labels.links,
            field: "links",
            render: getLinksNumber,
          },
          {
            title: I18n.get.form.labels.description,
            field: "description",
            width: 150,
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        order="ASC"
        orderBy="NAME"
        primaryField="name"
      />
    </Layout>
  );
};

export default Menus;
